import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useParallaxRef } from '@/utils/parallax';

interface OverviewTabProps {
  assetsCount?: number;
  nextPaymentDate?: string | null;
  openTicketsCount?: number;
}

export default function OverviewTab({ 
  assetsCount = 0, 
  nextPaymentDate = null,
  openTicketsCount = 0 
}: OverviewTabProps) {
  const navigate = useNavigate();
  const subtitleRef = useParallaxRef({ speed: -0.10, axis: 'y', maxTranslate: 32 });

  return (
    <>
      <CardHeader className="text-center pb-12">
        <CardTitle className="text-4xl md:text-5xl font-bold mb-6">Overview</CardTitle>
        <CardDescription ref={subtitleRef as any} className="text-xl md:text-2xl text-foreground/70 mb-20">
          Your account at a glance
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6 pt-4">
        <p className="text-muted-foreground">
          Welcome to your account dashboard. Here you can manage your domains, subscriptions, billing, and more.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="border rounded-lg p-4">
            <p className="text-sm text-muted-foreground mb-1">Active domains</p>
            <p className="text-2xl font-semibold">{assetsCount}</p>
          </div>
          <div className="border rounded-lg p-4">
            <p className="text-sm text-muted-foreground mb-1">Next payment</p>
            <p className="text-2xl font-semibold">
              {nextPaymentDate ? new Date(nextPaymentDate).toLocaleDateString() : '—'}
            </p>
          </div>
          <div className="border rounded-lg p-4">
            <p className="text-sm text-muted-foreground mb-1">Open support tickets</p>
            <p className="text-2xl font-semibold">{openTicketsCount}</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-3 pt-4">
          <Button onClick={() => navigate('/domains')} className="w-full sm:w-auto transition-all duration-150 hover:-translate-y-[1px] hover:shadow-md">
            Browse Domains
          </Button>
          <Button variant="outline" onClick={() => navigate('/account?tab=billing')} className="w-full sm:w-auto transition-all duration-150 hover:-translate-y-[1px] hover:shadow-md">
            Manage Billing
          </Button>
          <Button variant="outline" onClick={() => navigate('/account?tab=support')} className="w-full sm:w-auto transition-all duration-150 hover:-translate-y-[1px] hover:shadow-md">
            Contact Support
          </Button>
        </div>
      </CardContent>
    </>
  );
}

